import * as jsPdf from 'jspdf';
import { EInputMask } from 'src/Components/EInput';
import { IDispatchItem, IDispatchTruckTicket } from 'src/Interfaces/DispatchInterface';
import { equalGrid, equalLinesVertical } from '../MudReport/DrawReportMud';
import { fillEmptyRows } from '../MudReport/PopDataMud';
import { textArrayInBoxes } from '../PopulateDataMethods';
import * as MM from './SpecMilsTruckTicket';


const mask = new EInputMask();
export const createTruckTicket = (truck: IDispatchTruckTicket, logoBlob: HTMLImageElement, truckTicket: jsPdf) => {
    truckTicket.setFillColor(MM.HEADER_COLOR);
    const productArr = truck.items.filter(i => i.product !== null);
    const productLength = productArr.length;
    let productCount = 0;
    const ebpArr = truck.items.filter(i => i.expense !== null);
    const ebpLength = ebpArr.length;
    let ebpCount = 0;
    let pageNum = 1;

    drawHeader(truck, logoBlob, truckTicket);
    popOperatorInfo(truck, truckTicket);
    let topLocation = MM.DATA_TOP as number;
    while (productCount < productLength) {
        const { bottomLoc, productNum } = populateProductTable(productArr, productCount, topLocation, truckTicket);
        if (bottomLoc) {
            topLocation = bottomLoc + MM.SECTION_GAP_WIDTH;
        } else {
            popFooter(truck, pageNum++, truckTicket);
            truckTicket.addPage();
            drawHeader(truck, logoBlob, truckTicket);
            topLocation = MM.OPERATOR_TOP;
        }

        productCount = productNum;

    }
    let addedFooter = false;
    while (ebpCount < ebpLength) {
        ebpCount = populateEbpTable(ebpArr, ebpCount, topLocation, truckTicket);
        popFooter(truck, pageNum++, truckTicket);
        addedFooter = true;
        if (ebpCount < ebpLength) {
            truckTicket.addPage();
            drawHeader(truck, logoBlob, truckTicket);
            topLocation = MM.OPERATOR_TOP;
        }
    }

    if (!addedFooter) {
        popFooter(truck, pageNum++, truckTicket);
    }

};

export const drawHeader = (truck: IDispatchTruckTicket, logoBlob: HTMLImageElement, truckTicket: jsPdf) => {
    truckTicket.addImage(logoBlob, 'PNG', MM.LOGO_LEFT, MM.LOGO_TOP, MM.LOGO_WIDTH, MM.LOGO_HEIGHT);
    popHeaders(truck, truckTicket);
};

export const popHeaders = (truck: IDispatchTruckTicket, truckTicket: jsPdf) => {
    const tenant = truck.tenant;
    const headerArr = [
        [undefined, undefined],
        [tenant.tenantCompanyName, undefined],
        [tenant.address1, truck.ticketNumber ? truck.ticketNumber : truck.id],
        [tenant.address2, undefined],
        [mask.phone(tenant.phone), `${truck.driverName || ''}/${truck.swamperName || ''}`],
    ];

    const boldHeaderArr = [
        [undefined, undefined],
        [undefined, truck.type + 'Ticket #'],
        [undefined, undefined],
        [undefined, 'Driver/Swamper'],
        [undefined, undefined],
    ];

    const remainingWidth = MM.FULL_WIDTH
        - MM.LOGO_LEFT
        - MM.LOGO_WIDTH
        - MM.SECTION_GAP_WIDTH * 2;

    const headerLeft = MM.LOGO_LEFT + MM.LOGO_WIDTH + MM.SECTION_GAP_WIDTH;
    truckTicket.setFontSize(9);
    textArrayInBoxes(headerArr, headerLeft, MM.LOGO_TOP, remainingWidth, MM.LOGO_HEIGHT, 'center', truckTicket);
    truckTicket.setFontStyle('bold');
    textArrayInBoxes(boldHeaderArr, headerLeft, MM.LOGO_TOP, remainingWidth, MM.LOGO_HEIGHT, 'center', truckTicket);
    truckTicket.setFontStyle('normal');


};

const popOperatorInfo = (truck: IDispatchTruckTicket, truckTicket: jsPdf) => {


    const headerArr = [
        ['Customer', undefined, 'ETA', undefined],
        ['Address', undefined, 'Warehouse', undefined],
        ['City/State/Zip', undefined, 'Rig', undefined],
        ['Well Name', undefined, 'County', undefined],
        ['Ordered By', undefined, 'State', undefined],
    ];

    const dataArr = [
        [undefined, truck.operatorName, undefined, truck.dateShipped],
        [undefined, truck.operatorAddress, undefined, truck.warehouseName],
        [undefined, truck.operatorCityStateZip, undefined, `${truck.contractorName} #${truck.rigNumber}`],
        [undefined, truck.wellName, undefined, truck.county],
        [undefined, truck.orderedBy, undefined, truck.state],
    ];
    truckTicket.setFillColor(MM.HEADER_COLOR);
    truckTicket.rect(MM.OPERATOR_LEFT, MM.OPERATOR_TOP, MM.OPERATOR_WIDTH / 4, MM.OPERATOR_HEIGHT, 'F');
    truckTicket.rect(MM.OPERATOR_LEFT + MM.OPERATOR_WIDTH / 2, MM.OPERATOR_TOP, MM.OPERATOR_WIDTH / 4, MM.OPERATOR_HEIGHT, 'F');
    tableDraw(truckTicket);
    equalGrid(MM.OPERATOR_LEFT, MM.OPERATOR_TOP, MM.OPERATOR_WIDTH, MM.OPERATOR_HEIGHT, 5, 4, truckTicket);
    borderDraw(truckTicket);
    truckTicket.rect(MM.OPERATOR_LEFT, MM.OPERATOR_TOP, MM.OPERATOR_WIDTH, MM.OPERATOR_HEIGHT);
    tableDraw(truckTicket);
    textArrayInBoxes(dataArr, MM.OPERATOR_LEFT, MM.OPERATOR_TOP, MM.OPERATOR_WIDTH, MM.OPERATOR_HEIGHT, 'left', truckTicket);
    truckTicket.setFontStyle('bold');
    textArrayInBoxes(headerArr, MM.OPERATOR_LEFT, MM.OPERATOR_TOP, MM.OPERATOR_WIDTH, MM.OPERATOR_HEIGHT, 'left', truckTicket);
    truckTicket.setFontStyle('normal');
};

const populateProductTable = (productArr: IDispatchItem[], startIndex: number, top: number, truckTicket: jsPdf) => {


    const quantityHeaderArr =
        [
            ['Quantity']

        ];


    const productHeaderArr =
        [
            ['Product']
        ];


    const otherProductHeaders =
        [
            ['Unit', 'Size', 'Total Weight (lbs)']
        ];

    let productLinesAvailable = (MM.FULL_HEIGHT - top - MM.FOOTER_HEIGHT - MM.PAGE_NUM_HEIGHT - MM.PAGE_BORDER_WIDTH) / MM.DATA_ROW_HEIGHT - 1;
    productLinesAvailable -= productArr.filter(i => i.product.isHazardous).length;

    const productLinesNeeded = productArr.length - startIndex + 1;
    const newPage = productLinesNeeded > productLinesAvailable;
    const productLength = newPage ? productLinesAvailable : productLinesNeeded;

    const productQuantityArr = productArr.slice(startIndex, startIndex + productLength).filter(i => !i.deletedProduct && i.quantity !== 0).map(i => [i.quantity ? i.quantity.toFixed(2).replace(/\.00$/, '') : ''
    ]
    );
    productQuantityArr.unshift(undefined as any);

    const hazardousInfo = (product: any) => {
        let name = product.name;
        if (product.isHazardous) {
            if (product.properShippingName !== null)
            {
                name += ' ' + product.properShippingName;
            }
            if (product.hazardClass !== null)
            {
                name += ' ' + product.hazardClass;
            }
            if(product.packingGroup !== null)
            {
                name += ' ' + product.packingGroup;
            }
            if(product.identificationNumber !== null)
            {
                name += ' ' + product.identificationNumber;
            }
        }
        return name;

    };

    const productNameArr = productArr.slice(startIndex, startIndex + productLength).filter(i => !i.deletedProduct && i.quantity !== 0).map(i => [

        hazardousInfo(i.product),
    ]
    );
    console.log(productNameArr);

    productNameArr.unshift(undefined as any);

    const otherProductDataArr = productArr.slice(startIndex, startIndex + productLength).filter(i => !i.deletedProduct && i.quantity !== 0).map(i => [i.product.unit, i.product.size, (Number(i.product.weight) * Number(i.quantity)).toLocaleString()
    ]
    );
    otherProductDataArr.unshift(undefined as any);

    fillEmptyRows(productQuantityArr, productNameArr.length);
    fillEmptyRows(productNameArr, productNameArr.length);
    fillEmptyRows(otherProductDataArr, productNameArr.length);

    const productHeight = (productLength + 1) * MM.DATA_ROW_HEIGHT;

    truckTicket.setFillColor(MM.HEADER_COLOR);
    truckTicket.rect(MM.DATA_LEFT, top, MM.DATA_WIDTH, MM.DATA_ROW_HEIGHT, 'F');
    borderDraw(truckTicket);
    truckTicket.rect(MM.DATA_LEFT, top, MM.DATA_WIDTH, productHeight);
    tableDraw(truckTicket);

    equalLinesVertical(MM.DATA_LEFT, top, MM.FULL_WIDTH / 10, productHeight, 1, truckTicket);
    equalLinesVertical(MM.DATA_LEFT + (MM.FULL_WIDTH / 10.0), top, (MM.FULL_WIDTH / 10.0) * 6.0, productHeight, 1, truckTicket);
    equalLinesVertical(MM.DATA_LEFT + ((MM.FULL_WIDTH / 10.0) * 7.0), top, (MM.FULL_WIDTH / 10.0) * 3.0, productHeight, 3, truckTicket);

    truckTicket.setFontStyle('bold');
    textArrayInBoxes(quantityHeaderArr, MM.DATA_LEFT, top, MM.DATA_WIDTH / 10, MM.DATA_ROW_HEIGHT, 'center', truckTicket);
    truckTicket.setFontStyle('bold');
    textArrayInBoxes(productHeaderArr, MM.DATA_LEFT + (MM.DATA_WIDTH / 10.0), top, (MM.FULL_WIDTH / 10.0) * 6.0, MM.DATA_ROW_HEIGHT, 'center', truckTicket);
    truckTicket.setFontStyle('bold');
    textArrayInBoxes(otherProductHeaders, MM.DATA_LEFT + ((MM.FULL_WIDTH / 10.0) * 7.0), top, (MM.FULL_WIDTH / 10.0) * 3.0, MM.DATA_ROW_HEIGHT, 'center', truckTicket);
    truckTicket.setFontStyle('normal');
    textArrayInBoxes(productQuantityArr, MM.DATA_LEFT, top, MM.FULL_WIDTH / 10, productHeight, 'center', truckTicket);
    truckTicket.setFontStyle('normal');
    textArrayInBoxes(productNameArr, MM.DATA_LEFT + (MM.FULL_WIDTH / 10.0), top, (MM.FULL_WIDTH / 10.0) * 6.0, productHeight, 'center', truckTicket);
    truckTicket.setFontStyle('normal');
    textArrayInBoxes(otherProductDataArr, MM.DATA_LEFT + ((MM.FULL_WIDTH / 10.0) * 7.0), top, (MM.FULL_WIDTH / 10.0) * 3.0, productHeight, 'center', truckTicket);

    return {
        bottomLoc: newPage ? undefined : top + productHeight + MM.SECTION_GAP_WIDTH,
        productNum: startIndex + productLength
    };

};

// const populateProductTable = (productArr: IDispatchItem[], startIndex: number, top: number, truckTicket: jsPdf) => {
//     const productHeaderArr = [
//         ['Product', 'Quantity', 'Unit', 'Size', 'Total Weight (lbs)'],
//     ];

//     const productLinesAvailable = (MM.FULL_HEIGHT - top - MM.FOOTER_HEIGHT - MM.PAGE_NUM_HEIGHT - MM.PAGE_BORDER_WIDTH) / MM.DATA_ROW_HEIGHT - 1;

//     const productLinesNeeded = productArr.length - startIndex;
//     const newPage = productLinesNeeded > productLinesAvailable;
//     const productLength = newPage ? productLinesAvailable : productLinesNeeded;

//     const productDataArr = productArr.slice(startIndex, startIndex + productLength).filter(i => !i.deletedProduct && i.quantity !== 0).map(i => [i.product.name, i.quantity ? i.quantity.toFixed(2).replace(/\.00$/, '') : '', i.product.unit, i.product.size, (Number(i.product.weight) * Number(i.quantity)).toLocaleString()
//         ]
//     );
//     productDataArr.unshift(undefined as any);

//     fillEmptyRows(productHeaderArr, productDataArr.length);

//     const productHeight = (productLength + 1) * MM.DATA_ROW_HEIGHT;
//     truckTicket.setFillColor(MM.HEADER_COLOR);
//     truckTicket.rect(MM.DATA_LEFT, top, MM.DATA_WIDTH, MM.DATA_ROW_HEIGHT, 'F');
//     borderDraw(truckTicket);
//     truckTicket.rect(MM.DATA_LEFT, top, MM.DATA_WIDTH, productHeight);
//     tableDraw(truckTicket);


//     equalLinesVertical(MM.DATA_LEFT, top, MM.DATA_WIDTH, productHeight, 5, truckTicket);

//     truckTicket.setFontStyle('bold');
//     textArrayInBoxes(productHeaderArr, MM.DATA_LEFT, top, MM.DATA_WIDTH, productHeight, 'center', truckTicket);
//     truckTicket.setFontStyle('normal');
//     textArrayInBoxes(productDataArr, MM.DATA_LEFT, top, MM.DATA_WIDTH, productHeight, 'center', truckTicket);

//     return {
//         bottomLoc: newPage ? undefined : top + productHeight + MM.SECTION_GAP_WIDTH,
//         productNum: startIndex + productLength
//     };

// };

const populateEbpTable = (ebpArr: IDispatchItem[], startIndex: number, top: number, truckTicket: jsPdf) => {

    const expenseHeaderArr = [
        ['EBP', 'Quantity', 'Total Weight (lbs)']
    ];

    const ebpLinesAvailable = (MM.FULL_HEIGHT - top - MM.FOOTER_HEIGHT - MM.PAGE_NUM_HEIGHT - MM.PAGE_BORDER_WIDTH) / MM.DATA_ROW_HEIGHT - 1;

    const ebpLinesNeeded = ebpArr.length - startIndex;
    const newPage = ebpLinesNeeded > ebpLinesAvailable;
    const ebpLength = newPage ? ebpLinesAvailable : ebpLinesNeeded;
    const ebpHeight = (ebpLength + 1) * MM.DATA_ROW_HEIGHT;

    const expenseDataArr = ebpArr.slice(startIndex, startIndex + ebpLength).map(i => [
        i.expense.name, i.quantity ? i.quantity : '', i.expense.weight ? (Number(i.expense.weight) * Number(i.quantity)).toLocaleString() : '',
    ]);

    truckTicket.setFillColor(MM.HEADER_COLOR);
    truckTicket.rect(MM.DATA_LEFT, top, MM.DATA_WIDTH, MM.DATA_ROW_HEIGHT, 'F');
    borderDraw(truckTicket);
    truckTicket.rect(MM.DATA_LEFT, top, MM.DATA_WIDTH, ebpHeight);
    tableDraw(truckTicket);

    expenseDataArr.unshift(undefined as any);



    equalLinesVertical(MM.DATA_LEFT, top, MM.DATA_WIDTH, ebpHeight, 3, truckTicket);

    fillEmptyRows(expenseHeaderArr, expenseDataArr.length);

    truckTicket.setFontStyle('bold');
    textArrayInBoxes(expenseHeaderArr, MM.DATA_LEFT, top, MM.DATA_WIDTH, ebpHeight, 'center', truckTicket);
    truckTicket.setFontStyle('normal');
    textArrayInBoxes(expenseDataArr, MM.DATA_LEFT, top, MM.DATA_WIDTH, ebpHeight, 'center', truckTicket);
    return startIndex + ebpLength;

};

const popFooter = (truck: IDispatchTruckTicket, pageNum: number, truckTicket: jsPdf) => {
    const totalWeight = truck.items.reduce((pv, cv) => {
        if (cv.product === null) {
            return pv + Number(cv.quantity) * Number(cv.expense.weight);
        } else {
            return pv + Number(cv.quantity) * Number(cv.product.weight);
        }
    }, 0);

    const footerArr = [
        [`Truck Weight: ${totalWeight.toLocaleString()} (lbs)`, 'Date:', 'Signature:']
    ];

    borderDraw(truckTicket);
    truckTicket.rect(MM.FOOTER_LEFT, MM.FOOTER_TOP, MM.FOOTER_WIDTH, MM.FOOTER_HEIGHT);
    tableDraw(truckTicket);
    equalGrid(MM.FOOTER_LEFT, MM.FOOTER_TOP, MM.FOOTER_WIDTH, MM.FOOTER_HEIGHT, 1, 3, truckTicket);


    truckTicket.setFontStyle('bold');
    textArrayInBoxes(footerArr, MM.FOOTER_LEFT, MM.FOOTER_TOP, MM.FOOTER_WIDTH, MM.FOOTER_HEIGHT, 'left', truckTicket);
    truckTicket.setFontSize(7);
    const footerPageAndDisclaim = [
        ['NOTICE: ANY OPINION AND/OR RECOMMENDATION, EXPRESSED ORALLY OR WRITTEN HEREIN, HAS BEEN PREPARED CAREFULLY AND MAY BE USED'],
        ['IF THE USER SO ELECTS. HOWEVER, NO REPRESENTATION OR WARRANTY IS MADE BY OURSELVES OR OUR AGENTS AS TO ITS CORRECTNESS'],
        ['OR COMPLETENESS AND NO LIABILITY IS ASSUMED FOR DAMAGES RESULTING FROM THE USE OF SAME.'],
        [pageNum.toString()]
    ];
    textArrayInBoxes(footerPageAndDisclaim, MM.FOOTER_LEFT, MM.PAGE_NUM_TOP, MM.FOOTER_WIDTH, MM.PAGE_NUM_HEIGHT, 'center', truckTicket);
    truckTicket.setFontSize(9);
};

const borderDraw = (mudReport: jsPdf) => {
    mudReport.setDrawColor(MM.OUTER_BORDER_COLOR);
    mudReport.setLineWidth(MM.OUTER_BORDER_WIDTH);
};

const tableDraw = (mudReport: jsPdf) => {
    mudReport.setDrawColor(MM.INNER_BORDER_COLOR);
    mudReport.setLineWidth(MM.INNER_BORDER_WIDTH);
};


// WEBPACK FOOTER //
// ./src/Services/Pdf/TruckTicket/DrawTruckTicket.ts